import { render, staticRenderFns } from "./BreastOperationsPart.vue?vue&type=template&id=6e8af462&scoped=true&"
import script from "./BreastOperationsPart.ts?vue&type=script&lang=ts&"
export * from "./BreastOperationsPart.ts?vue&type=script&lang=ts&"
import style0 from "./BreastOperationsPart.scss?vue&type=style&index=0&id=6e8af462&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8af462",
  null
  
)

export default component.exports